import React, { useRef } from "react";
import { FaEye } from "react-icons/fa";
import MetaTags from "../../HeadTag/MetaTags";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { ArrowDown, ArrowUp, Calendar2 } from "react-bootstrap-icons";
import Tablelist from "../../../Hook/list";
import axios from "../../../Hook/utils/constants/server";

import { enqueueSnackbar } from "notistack";
import {
  BarChart,
  Bar,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import PieCharts from "../../../Hook/Recharts/PieCharts";
import "../Chartpage.css";
import { Backdrop } from "@mui/material";
import countryList from "../../../Components/Data/countries/countries.json";
import Loading from "../../../Hook/Spinner";
import { createSearchParams, useNavigate } from "react-router-dom";
import "./index.scss";
import { Formatdata, formatDate } from "../../../utils/transformActivityData";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const Widgets = () => {
  const navigate = useNavigate();

  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef();
  const [filters, setFilters] = useState({
    dates: { date: ["", ""] },
    planname: {
      default: { label: "All" }, // default value
      list: [
        { label: "All" },
        { label: "Free" },
        { label: "Basic" },
        { label: "Pro" },
        { label: "Premium" },
      ],
      triger: false,
    },
  });
  const [localRange, setLocalRange] = React.useState(
    filters.dates?.date?.length === 2 ? filters.dates.date : ["", ""]
  );
  const [range, setRange] = React.useState([
    {
      startDate: localRange[0] ? new Date(localRange[0]) : new Date(),
      endDate: localRange[1] ? new Date(localRange[1]) : new Date(),
      key: "selection",
    },
  ]);
  const appName = window.localStorage.getItem("activeApp")
    ? window.localStorage.getItem("activeApp")
    : "Wishlist Guru";
  useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    }

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  const handleDateChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    setRange([ranges.selection]);

    // Wait until both start and end dates are selected
    if (startDate && endDate) {
      const formattedStart = format(startDate, "yyyy-MM-dd");
      const formattedEnd = format(endDate, "yyyy-MM-dd");

      setLocalRange([formattedStart, formattedEnd]);

      // Call filter function
      // fetchTimely(formattedStart, formattedEnd);

      // Optional: close calendar after selection
      // setShowCalendar(false);
    }
  };

  let [users, setusers] = useState({
    activeInstalls: [],
    allInstalls: [],
    loading: false,
    toast: false,
    tabledata: {
      thead: [
        // {
        //   type: "text",
        //   title: "App Install Id",
        //   key: "app_install_id",
        // },
        {
          key: "date",
          title: "Date",
          type: "text",
        },
        // {
        //   key: "store_owner",
        //   title: "Store Owner",
        //   type: "text",
        // },
        {
          type: "link",
          title: "Store Name",
          element: {
            type: "view",
            key: "store_name",
            url: "shop_name",
          },
        },

        {
          key: "active_plan_name",
          title: "Plan",
          type: "text",
        },
        // {
        //   key: "country",
        //   title: "Country",
        //   type: "text",
        // },
        {
          key: "status",
          title: "Status",
          type: "text",
        },
        {
          element: [
            {
              type: "view",
              // action: (e, store_id) => {
              //   navigate({
              //     pathname: "/dashboard/reports/details",
              //     search: createSearchParams({ id: store_id }).toString(),
              //   });
              //   window.open(url, "_blank");
              // },
              icon: <FaEye color={"#f5aa33"} />,
              action: (e, store_id) => {
                e.preventDefault();
                const url = `/dashboard/reports/details?id=${store_id}`;
                window.open(url, "_blank");
              },
            },
          ],
          title: "Action",
          type: "action",
        },
      ],
      tbody: [],
    },
  });
  const localRangeRef = useRef(localRange);

  useEffect(() => {
    localRangeRef.current = localRange;
  }, [filters, range]);
  const [countryWiseInstalls, setCountryWiseInstalls] = React.useState({
    frequency: "all",
    tabledata: {
      thead: [
        {
          type: "text",
          title: "Install Count",
          key: "install_count",
        },
        {
          type: "text",
          title: "Country",
          key: "country_name",
        },
        {
          type: "text",
          title: "Store Type",
          key: "store_type",
        },
        {
          type: "thumbnail",
          title: "Flag",
          image: "image",
        },
      ],
      tbody: [],
    },
  });
  const [barData, setBarData] = useState([]);
  let [monthlyRevenue, setMonthlyRevenue] = useState({
    currentMonthRevenue: {
      totalprice: 0,
      currentMonthName: "",
    },
    previousMonthRevenue: {
      totalprice: 0,
      previousMonthName: "",
    },
    currentMonthRevenueOverAll: {
      totalprice: 0,
      currentMonthName: "",
    },
    previousMonthRevenueOverAll: {
      totalprice: 0,
      previousMonthName: "",
    },

    currentRevenueYearly: {
      totalprice: 0,
      currentMonthName: "",
    },
    previousRevenueYearly: {
      totalprice: 0,
      previousMonthName: "",
    },
    currentRevenueOverallYearly: {
      totalprice: 0,
      currentMonthName: "",
    },
    previousRevenueOverallYearly: {
      totalprice: 0,
      previousMonthName: "",
    },
  });
  // let [widgetretention, setWidgetRetention] = useState({
  //   currentMonthRetentionPercent: null,
  //   previousMonthRetentionPercent: null,
  //   currentMonthActiveRecords: null,
  //   currentMonthTotalRecords: null,
  //   previousMonthActiveRecords: null,
  //   previousMonthTotalRecords: null,
  // });

  let [widgetretention, setWidgetRetention] = useState({
    currentMonthRetentionPercent: null,
    previousMonthRetentionPercent: null,
    currentMonthActiveRecords: null,
    currentMonthTotalRecords: null,
    previousMonthActiveRecords: null,
    previousMonthTotalRecords: null,

    currentMonthRetentionPercentOverAll: null,
    previousMonthRetentionPercentOverAll: null,
    currentMonthActiveRecordsOverAll: null,
    previousMonthActiveRecordsOverAll: null,
    currentMonthTotalRecordsOverAll: null,
    previousMonthTotalRecordsOverAll: null,
  });

  // let [revenueByDeviceData, setrevenueByDeviceData] = useState("week");

  const [appwidget, setAppWidget] = useState([]);
  const [showdropdownfilter, setShowdropdownfilter] = useState({
    showdropdown: false,
    status: "all",
    frequency: "all",
  });

  const [charttabledata, setChartTableData] = useState({
    frequencyType: "week",
    thead: [
      {
        key: "name",
        title: "Plan Name",
        type: "text",
      },
      {
        key: "percent",
        title: "Percent(%)",
        type: "text",
      },
      {
        key: "value",
        title: "Value",
        type: "text",
      },
      {
        type: "action",
        title: "Action",
        element: [
          {
            type: "viewfilter",
            icon: <FaEye color="#f5aa33" />,
            action: (e, row) => {
              e.preventDefault();
              const plan = row?.name?.toLowerCase();
              const [start, end] = localRangeRef.current;
              let url = "/dashboard/activity-logs";
              if (start || end) {
                url = `/dashboard/activity-logs?plan=${encodeURIComponent(
                  plan
                )}&daterange=${start}%20${end}`;
              } else {
                url = `/dashboard/activity-logs?plan=${encodeURIComponent(
                  plan
                )}`;
              }

              window.open(url, "_blank");
            },
          },
        ],
      },
    ],
    tbody: [],
  });
  const setAll = () =>
    setShowdropdownfilter({ ...showdropdownfilter, status: "all" });
  const setActive = () =>
    setShowdropdownfilter({ ...showdropdownfilter, status: "Active" });
  const setInActive = () =>
    setShowdropdownfilter({ ...showdropdownfilter, status: "inActive" });

  // const allActiveBarData = (frequency) => {
  //   let testValue = [];

  //   const data = frequency.map((item) => ({
  //     name: item.currentDate,
  //     label: item.currentDate,
  //     installcount: item.count,
  //   }));

  //   data.sort((a, b) => {
  //     let firstDate = Date.parse(a.name);
  //     let secondDate = Date.parse(b.name);
  //     return new Date(secondDate) - new Date(firstDate);
  //   });

  //   setBarData(data);
  // };
  const allActiveBarData = (frequency) => {
    const data = frequency.map((item) => ({
      name: item.currentDate,
      label: item.currentDate,
      installed: item.installed || 0,
      uninstalled: item.uninstalled || 0,
    }));

    data.sort((a, b) => new Date(a.name) - new Date(b.name));
    setBarData(data);
  };

  // const calculateWidgetRevenue = (
  //   positive,
  //   previousPositive,
  //   currentMonth,
  //   previousMonth,
  //   positiveAll,
  //   previousPositiveAll
  // ) => {
  //   let currentRevenue = 0;
  //   let previousRevenue = 0;
  //   let previousRevenueOverAll = 0;
  //   let currentRevenueOverAll = 0;
  //   let currentRevenueYearly = 0;
  //   let previousRevenueYearly = 0;
  //   let currentRevenueOY = 0;
  //   let previousRevenueOY = 0;
  //   let currentRevenueY = 0;
  //   let previousRevenueY = 0;
  //   const sum = (a, b) => {
  //     return a + b;
  //   };
  //   const calculateRevenueMonthly = (data, isCurrent = true) => {
  //     let total = 0;
  //     data.forEach((item) => {
  //       const monthlyPlansPrice = item.total_monthly_price;
  //       //const YearlyPlansPrice = item.total_annual_price;
  //       total = total + monthlyPlansPrice; //sum(monthlyPlansPrice,YearlyPlansPrice);
  //     });
  //     return total;
  //   };
  //   const calculateRevenueAnnually = (data, isCurrent = true) => {
  //     let total = 0;
  //     data.forEach((item) => {
  //       const YearlyPlansPrice = item.total_annual_price;
  //       total = total + YearlyPlansPrice;
  //     });
  //     return total;
  //   };
  //   const calculateRevenueOverAll = (data, isCurrent = true) => {
  //     let totalAll = 0;
  //     data.forEach((item) => {
  //       const monthlyPlansPrice = item.total_monthly_price;
  //       //const YearlyPlansPrice = item.total_annual_price;
  //       totalAll = totalAll + monthlyPlansPrice; //sum(monthlyPlansPrice,YearlyPlansPrice);
  //     });
  //     return totalAll;
  //   };
  //   const calculateRevenueOverAllYearly = (data, isCurrent = true) => {
  //     let total = 0;
  //     data.forEach((item) => {
  //       const YearlyPlansPrice = item.total_annual_price;
  //       total = total + YearlyPlansPrice;
  //     });
  //     return total;
  //   };

  //   currentRevenue = calculateRevenueMonthly(positive, true);
  //   previousRevenue = calculateRevenueMonthly(previousPositive, false);

  //   currentRevenueY = calculateRevenueAnnually(positive, false);
  //   previousRevenueY = calculateRevenueAnnually(previousPositive, false);

  //   currentRevenueOY = calculateRevenueOverAllYearly(positiveAll, true);
  //   previousRevenueOY = calculateRevenueOverAllYearly(
  //     previousPositiveAll,
  //     false
  //   );

  //   currentRevenueOverAll = calculateRevenueOverAll(positiveAll, true);
  //   previousRevenueOverAll = calculateRevenueOverAll(
  //     previousPositiveAll,
  //     false
  //   );

  //   return {
  //     currentMonthRevenue: {
  //       totalprice: currentRevenue.toFixed(2),
  //       currentMonthName: currentMonth,
  //     },
  //     previousMonthRevenue: {
  //       totalprice: previousRevenue.toFixed(2),
  //       previousMonthName: previousMonth,
  //     },
  //     currentMonthRevenueOverAll: {
  //       totalprice: currentRevenueOverAll.toFixed(2),
  //       currentMonthName: currentMonth,
  //     },
  //     previousMonthRevenueOverAll: {
  //       totalprice: previousRevenueOverAll.toFixed(2),
  //       previousMonthName: previousMonth,
  //     },
  //     currentRevenueYearly: {
  //       totalprice: currentRevenueY.toFixed(2),
  //       currentMonthName: currentMonth,
  //     },
  //     previousRevenueYearly: {
  //       totalprice: previousRevenueY.toFixed(2),
  //       previousMonthName: previousMonth,
  //     },
  //     currentRevenueOverallYearly: {
  //       totalprice: currentRevenueOY.toFixed(2),
  //       currentMonthName: currentMonth,
  //     },
  //     previousRevenueOverallYearly: {
  //       totalprice: previousRevenueOY.toFixed(2),
  //       previousMonthName: previousMonth,
  //     },
  //   };
  // };
const calculateWidgetRevenue = (
  positive,
  previousPositive,
  currentMonth,
  previousMonth,
  positiveAll,
  previousPositiveAll
) => {
  const safeSum = (arr, key) => {
    if (!Array.isArray(arr)) return 0;
    return arr.reduce((total, item) => {
      const value = Number(item[key]) || 0;
      return total + value;
    }, 0);
  };

  const currentRevenue = safeSum(positive, "total_monthly_price");
  const previousRevenue = safeSum(previousPositive, "total_monthly_price");

  const currentRevenueY = safeSum(positive, "total_annual_price");
  const previousRevenueY = safeSum(previousPositive, "total_annual_price");

  const currentRevenueOverAll = safeSum(positiveAll, "total_monthly_price");
  const previousRevenueOverAll = safeSum(previousPositiveAll, "total_monthly_price");

  const currentRevenueOY = safeSum(positiveAll, "total_annual_price");
  const previousRevenueOY = safeSum(previousPositiveAll, "total_annual_price");

  const format = (num) => Number(num || 0).toFixed(2);

  return {
    currentMonthRevenue: { totalprice: format(currentRevenue), currentMonthName: currentMonth },
    previousMonthRevenue: { totalprice: format(previousRevenue), previousMonthName: previousMonth },
    currentMonthRevenueOverAll: { totalprice: format(currentRevenueOverAll), currentMonthName: currentMonth },
    previousMonthRevenueOverAll: { totalprice: format(previousRevenueOverAll), previousMonthName: previousMonth },
    currentRevenueYearly: { totalprice: format(currentRevenueY), currentMonthName: currentMonth },
    previousRevenueYearly: { totalprice: format(previousRevenueY), previousMonthName: previousMonth },
    currentRevenueOverallYearly: { totalprice: format(currentRevenueOY), currentMonthName: currentMonth },
    previousRevenueOverallYearly: { totalprice: format(previousRevenueOY), previousMonthName: previousMonth },
  };
};

  const calculateWidgetRetention = (retentionStats) => {
    let currentMonthTotalRecords = 0;
    let currentMonthActiveRecords = 0;
    let previousMonthTotalRecords = 0;
    let previousMonthActiveRecords = 0;

    let currentMonthTotalRecordsOverAll = 0;
    let currentMonthActiveRecordsOverAll = 0;
    let previousMonthTotalRecordsOverAll = 0;
    let previousMonthActiveRecordsOverAll = 0;

    // Regular
    retentionStats.currentMonthRetention.forEach((record) => {
      currentMonthTotalRecords += record["count(app_install_id)"];
      if (record.status === "Active") {
        currentMonthActiveRecords += record["count(app_install_id)"];
      }
    });

    retentionStats.previousMonthRetention.forEach((record) => {
      previousMonthTotalRecords += record["count(app_install_id)"];
      if (record.status === "Active") {
        previousMonthActiveRecords += record["count(app_install_id)"];
      }
    });

    // Overall
    retentionStats.currentMonthRetentionOverAll.forEach((record) => {
      currentMonthTotalRecordsOverAll += record["count(app_install_id)"];
      if (record.status === "Active") {
        currentMonthActiveRecordsOverAll += record["count(app_install_id)"];
      }
    });

    retentionStats.previousMonthRetentionOverAll.forEach((record) => {
      previousMonthTotalRecordsOverAll += record["count(app_install_id)"];
      if (record.status === "Active") {
        previousMonthActiveRecordsOverAll += record["count(app_install_id)"];
      }
    });

    return {
      currentMonthRetentionPercent: currentMonthTotalRecords
        ? (
            (currentMonthActiveRecords / currentMonthTotalRecords) *
            100
          ).toFixed(2)
        : "0.00",
      previousMonthRetentionPercent: previousMonthTotalRecords
        ? (
            (previousMonthActiveRecords / previousMonthTotalRecords) *
            100
          ).toFixed(2)
        : "0.00",
      currentMonthActiveRecords,
      currentMonthTotalRecords,
      previousMonthActiveRecords,
      previousMonthTotalRecords,

      currentMonthRetentionPercentOverAll: currentMonthTotalRecordsOverAll
        ? (
            (currentMonthActiveRecordsOverAll /
              currentMonthTotalRecordsOverAll) *
            100
          ).toFixed(2)
        : "0.00",
      previousMonthRetentionPercentOverAll: previousMonthTotalRecordsOverAll
        ? (
            (previousMonthActiveRecordsOverAll /
              previousMonthTotalRecordsOverAll) *
            100
          ).toFixed(2)
        : "0.00",
      currentMonthActiveRecordsOverAll,
      currentMonthTotalRecordsOverAll,
      previousMonthActiveRecordsOverAll,
      previousMonthTotalRecordsOverAll,
    };
  };

  const calculateTenure = (tenure) => {
    let date = new Date();
    let currentDate = date.getDate();
    let currentMonth = date.getMonth();
    let currentYear = date.getFullYear();
    let beginningDate = `${currentYear}-${currentMonth}-01`;
    let todayDate = `${currentYear}-${currentMonth}-${currentDate}`;
    if (tenure === "week") {
      return {
        startdate: "",
        enddate: "",
      };
    } else if (tenure === "month") {
      return {
        startdate: beginningDate,
        enddate: todayDate,
      };
    } else
      return {
        startdate: "",
        enddate: "",
      };
  };
  const calculateGraphData = (data) => {
    // console.log(data, "datadatadata");
    let totalactiveusers = 0;
    data.forEach((datakey) => {
      totalactiveusers = totalactiveusers + datakey.count;
    });
    return data.map((datakey) => {
      if (
        datakey.active_plan_name !== "null" ||
        datakey.active_plan_name !== "No plan"
      )
        return {
          name: datakey.active_plan_name,
          value: datakey.count,
          percent: parseFloat((datakey.count / totalactiveusers) * 100).toFixed(
            2
          ),
        };
      else {
        return;
      }
    });
  };
  const formatCountryData = (data) => {
    return data.map((dataitem) => {
      const match = countryList.find(
        (country) => country.name === dataitem.country
      );
      return {
        install_count: dataitem.install_count,
        image: match ? match.code.toLowerCase() : "unknown",
        country_name: dataitem.country,
        store_type: dataitem.store_type,
      };
    });
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length)
      return (
        <>
          <div className="custom-tooltip bg-light p-1 rounded-2">
            <p
              className="m-0 p-0"
              style={{ color: "orangered", fontWeight: "bold" }}
            >
              Date: {payload[0].payload.label}
            </p>
            <p
              className="p-0 m-0"
              style={{ color: "orange", fontWeight: "bold" }}
            >
              Count: {payload[0].payload.installcount}
            </p>
          </div>
        </>
      );
    else return null;
  };
  //for the top header cards//
  useEffect(() => {
    setusers((users) => ({ ...users, loading: false }));
    axios
      .get(`/user/appinstalls`, {
        withCredentials: true,
        params: {
          status: showdropdownfilter.status,
          frequency: showdropdownfilter.frequency,
        },
        headers: {
          "Content-Type": "application/json",
          "x-app-name": appName,
        },
      })
      .then((response) => {
        if (
          response.data === "jwt expired" ||
          response.data === "jwt must be provided"
        ) {
          navigate("/");
          localStorage.clear();
        } else {
          allActiveBarData(response.data.data.barlist);
          setMonthlyRevenue(
            calculateWidgetRevenue(
              response.data.data.positive,
              response.data.data.previousPositive,
              response.data.data.currentMonth,
              response.data.data.previousMonth,
              response.data.data.positiveAll,
              response.data.data.previousPositiveAll
            )
          );
          setWidgetRetention(
            calculateWidgetRetention(response.data.data.retentionStats)
          );
          setAppWidget([
            {
              label: "Active Installs",
              type: "Active",
              count: response.data.data.totalInstalls,
            },
            {
              label: "Revenue",
              type: "revenue",
              count: response.data.data.list.length,
            },
            {
              label: "Retention",
              count: response.data.data.list.length,
              type: "retention",
            },
          ]);
        }
      })
      .catch((error) => {
        console.error("API call failed======:", error);
        if (error.response.status === 401) {
          navigate("/");
          localStorage.clear();
        }
      })
      .finally((response) => ({ ...users, loading: false }));
    return () => console.log("Component unmunts from the domn tree");
  }, []);
  //end//

  //for the chart data //
  useEffect(() => {
    setusers((users) => {
      return {
        ...users,
        loading: true,
      };
    });
    axios
      .get(`/user/appinstalls`, {
        params: {
          status: showdropdownfilter.status,
          frequency: showdropdownfilter.frequency,
        },
        headers: {
          "Content-Type": "application/json",
          "x-app-name": appName,
        },
      })
      .then((response) => {
        if (
          response.data === "jwt expired" ||
          response.data === "jwt must be provided"
        ) {
          localStorage.clear();
          navigate("/");
          enqueueSnackbar(`${response.data}, please login again to continue`, {
            autoHideDuration: 2000,
            variant: "info",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } else {
          setusers((users) => ({ ...users, loading: false }));

          if (showdropdownfilter.frequency === "all") {
            const data = response.data.data.piechartdata;
            // console.log(data, "222datadatadatadatadatadata");
            setChartTableData({
              ...charttabledata,
              tbody: calculateGraphData(data),
            });
          } else if (showdropdownfilter.frequency === "week") {
            const data = response.data.data.piechartDataWeek;
            const finalData =
              data && data.length > 0
                ? calculateGraphData(data)
                : [
                    { name: "No Data", value: 1, fill: "#e0e0e0", dummy: true }, // dummy slice
                  ];

            setChartTableData((prev) => ({
              ...prev,
              tbody: finalData,
            }));
          } else if (showdropdownfilter.frequency === "month") {
            const data = response.data.data.piechartDataMonth;
            setChartTableData({
              ...charttabledata,
              tbody: calculateGraphData(data),
            });
          } else if (showdropdownfilter.frequency === "thisweek") {
            const data = response.data.data.piechartdatathisweek;
            setChartTableData({
              ...charttabledata,
              tbody: calculateGraphData(data),
            });
          } else if (showdropdownfilter.frequency === "thismonth") {
            const data = response.data.data.piechartdatathismonth;
            setChartTableData({
              ...charttabledata,
              tbody: calculateGraphData(data),
            });
          }
        }
      })
      .catch((error) => {
        console.error("API call failed======:", error);
        if (error.response.status === 401) {
          navigate("/");
          localStorage.clear();
        }
      })
      .finally((response) =>
        setusers((users) => ({ ...users, loading: false }))
      );
  }, [showdropdownfilter.frequency]);
  //end//

  useEffect(() => {
    // console.log(localRange, "localRange");

    const buildParams = () => {
      const params = {};

      // Plan
      if (
        filters?.planname?.default?.label &&
        filters?.planname?.default?.label !== "All"
      ) {
        params.planType = filters.planname.default.label;
      }

      // Date range
      if (localRange[0] && localRange[1]) {
        params.dateStart = localRange[0];
        params.dateEnd = localRange[1];
      }

      return params;
    };
   // console.log(buildParams());
    axios("/user/appinstalls", {
      method: "GET",
      params: buildParams(),
      headers: {
        "Content-Type": "application/json",
        "x-app-name": appName,
      },
    }).then((response) => {
      if (
        response.data === "jwt expired" ||
        response.data === "jwt must be provided"
      ) {
        navigate("/");
        localStorage.clear();
      } else {
        const data = response.data.data.piechartFiltered;
        if (data) {
          setChartTableData({
            ...charttabledata,
            tbody: calculateGraphData(data),
          });
        }
      }
    });
  }, [filters, range]);
  //for the countrywiseinstalls//
  useEffect(() => {
    axios("/user/appinstalls", {
      method: "GET",
      params: {
        status: showdropdownfilter.status,
        frequency: showdropdownfilter.frequency,
      },
      headers: {
        "Content-Type": "application/json",
        "x-app-name": appName,
      },
    }).then((response) => {
      if (
        response.data === "jwt expired" ||
        response.data === "jwt must be provided"
      ) {
        navigate("/");
        localStorage.clear();
      } else {
        if (countryWiseInstalls.frequency === "all")
          setCountryWiseInstalls({
            ...countryWiseInstalls,
            tabledata: {
              ...countryWiseInstalls.tabledata,
              tbody: formatCountryData(response.data.data.countryWiseInstalls),
            },
          });
        else if (countryWiseInstalls.frequency === "week")
          setCountryWiseInstalls({
            ...countryWiseInstalls,
            tabledata: {
              ...countryWiseInstalls.tabledata,
              tbody: formatCountryData(
                response.data.data.countrywiseInstallsLastWeek
              ),
            },
          });
        else if (countryWiseInstalls.frequency === "month")
          setCountryWiseInstalls({
            ...countryWiseInstalls,
            tabledata: {
              ...countryWiseInstalls.tabledata,
              tbody: formatCountryData(
                response.data.data.countrywiseInstallsLastMonth
              ),
            },
          });
        else if (countryWiseInstalls.frequency === "thisweek")
          setCountryWiseInstalls({
            ...countryWiseInstalls,
            tabledata: {
              ...countryWiseInstalls.tabledata,
              tbody: formatCountryData(
                response.data.data.countrywiseInstallsThisWeek
              ),
            },
          });
        else if (countryWiseInstalls.frequency === "thismonth")
          setCountryWiseInstalls({
            ...countryWiseInstalls,
            tabledata: {
              ...countryWiseInstalls.tabledata,
              tbody: formatCountryData(
                response.data.data.countrywiseInstallsThisMonth
              ),
            },
          });
      }
    });
  }, [countryWiseInstalls.frequency]);
  //end//

  //for the table data//
  useEffect(() => {
    let dates = calculateTenure(showdropdownfilter.frequency);
    let payload = {
      startdate: dates.startdate,
      enddate: dates.enddate,
      status: showdropdownfilter.status,
      frequency: showdropdownfilter.frequency,
    };
    setusers((users) => ({ ...users, loading: true }));
    axios
      .get(`/user/appinstalls`, {
        params: {
          startdate: payload.startdate,
          enddate: payload.enddate,
          status: payload.status,
          frequency: payload.frequency,
        },
        headers: {
          "Content-Type": "application/json",
          "x-app-name": appName,
        },
      })
      .then((response) => {
        if (
          response.data === "jwt expired" ||
          response.data === "jwt must be provided"
        ) {
          navigate("/");
        } else {
          setusers({
            ...users,
            allInstalls: response.data.data.totalInstalls,
            tabledata: {
              ...users.tabledata,
              tbody: Formatdata(response.data.data.list),
            },
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error("API call failed======:", error);
        if (error.response.status === 401) {
          navigate("/");
          localStorage.clear();
        }
      })
      .finally((response) =>
        setusers((users) => ({ ...users, loading: false }))
      );
  }, [showdropdownfilter.status]);
  // //for the table data end//

  return (
    <>
      {users.loading ? (
        //  <CustomBackDrop >
        <Backdrop open>
          <Loading />
          {/* </CustomBackDrop>  */}
        </Backdrop>
      ) : (
        <div className="h-100">
          <MetaTags title={"Widgets"} />
          <div className="p-4 pb-0 heading-content bg-light">
            <h4 className="m-0">Widgets</h4>
          </div>
          <div className="container widget-container bg-light p-4">
            <Row className="bg-light d-flex justify-content-between mb-3">
              {appwidget.map((key, index) => (
                
                <>
                  {key.type === "Active" && (
                    <Col index={index} xs={12} md={6}>
                      <div className="grid-box 88888">
                        <Row className="content-overview align-items-start">
                          {/* Left Info Block */}
                          <Col sm={3}>
                            <h2>{key.count}</h2>
                            <p>{key.label}</p>
                            <p className="status-percentage mt-22">
                              <span>Since last week</span>
                            </p>
                          </Col>

                          {/* Right Bar Chart */}
                          <Col sm={9}>
                            <BarChart width={300} height={300}
                                data={barData}
                                margin={{
                                  top: 10,
                                  right: 10,
                                  left: 0,
                                  bottom: 50,
                                }}
                              >
                                <XAxis
                                  dataKey="label"
                                  angle={-45}
                                  textAnchor="end"
                                  height={60}
                                  interval={0}
                                  tick={{ fontSize: 12, fill: "#555" }}
                                />
                                <YAxis
                                  tick={{
                                    fontSize: 12,
                                    fill: "#333",
                                    fontWeight: "bold",
                                  }}
                                  allowDecimals={false}
                                />
                                <Tooltip />
                                <Legend layout="horizontal" align="center" verticalAlign="bottom" wrapperStyle={{ paddingTop: 10 }} />

                                {/* Stacked Bars */}
                                <Bar
                                  dataKey="installed"
                                  stackId="apps"
                                  fill="#1f77b4"
                                  name="Installed Apps"
                                />
                                <Bar
                                  dataKey="uninstalled"
                                  stackId="apps"
                                  fill="#d62728"
                                  name="Uninstalled Apps"
                                />
                              </BarChart>

                            {/* <ResponsiveContainer width={250} height={250}>
                              <BarChart
                                data={barData}
                                margin={{
                                  top: 10,
                                  right: 10,
                                  left: 0,
                                  bottom: 50,
                                }}
                              >
                                <XAxis
                                  dataKey="label"
                                  angle={-45}
                                  textAnchor="end"
                                  height={60}
                                  interval={0}
                                  tick={{ fontSize: 12, fill: "#555" }}
                                />
                                <YAxis
                                  tick={{
                                    fontSize: 12,
                                    fill: "#333",
                                    fontWeight: "bold",
                                  }}
                                  allowDecimals={false}
                                  domain={[0, "dataMax + 1"]}
                                />
                                <Tooltip content={<CustomTooltip />} />
                                <Bar
                                  dataKey="installcount"
                                  fill="#f5aa33"
                                  barSize={30}
                                />
                              </BarChart>
                            </ResponsiveContainer> */}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  )}

                  {key.type === "revenue" && (
                    <Col index={index} xs={12} md={6}>
                      <div className="grid-box p-4 border rounded shadow-sm">
                        <Row className="content-overview align-items-start">
                          {/* LEFT SIDE: Current and Previous Revenue */}
                          <Col sm={6}>
                            <h4 className="mb-2 text-lg font-semibold">
                              ${monthlyRevenue.currentMonthRevenue.totalprice} –
                              M
                              <br />$
                              {monthlyRevenue.currentRevenueYearly.totalprice} –
                              Y
                            </h4>
                            <p className="d-flex gap-1 text-sm text-muted">
                              <span>{key.label}</span> –
                              <span style={{ color: "#f5aa33" }}>
                                {
                                  monthlyRevenue.currentMonthRevenue
                                    .currentMonthName
                                }
                              </span>
                            </p>

                            {/* Change % */}
                            <p className="status-percentage my-2 text-sm">
                              <span
                                className={
                                  monthlyRevenue.currentMonthRevenue
                                    .totalprice >
                                  monthlyRevenue.previousMonthRevenue.totalprice
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {monthlyRevenue.currentMonthRevenue.totalprice >
                                monthlyRevenue.previousMonthRevenue
                                  .totalprice ? (
                                  <ArrowUp className="text-success me-1" />
                                ) : (
                                  <ArrowDown className="text-danger me-1" />
                                )}
                                {(() => {
                                  const curr = parseFloat(monthlyRevenue.currentMonthRevenue.totalprice) || 0;
                                  const prev = parseFloat(monthlyRevenue.previousMonthRevenue.totalprice) || 0;
                                  const denom = curr > prev ? curr : prev;
                                  return denom === 0 ? "0.00" : (Math.abs(curr - prev) / denom).toFixed(2);
                                })()}
                                %
                              </span>
                              <span className="ms-2">Since last month</span>
                            </p>

                            {/* Previous Month */}
                            <p className="d-flex gap-1 status-percentage mt-3 text-sm">
                              <span>
                                {
                                  monthlyRevenue.previousMonthRevenue
                                    .previousMonthName
                                }
                              </span>{" "}
                              –
                              <span style={{ color: "#f5aa33" }}>
                                $
                                {monthlyRevenue.previousMonthRevenue.totalprice}{" "}
                                – M
                              </span>{" "}
                              |
                              <span style={{ color: "#f5aa33" }}>
                                $
                                {
                                  monthlyRevenue.previousRevenueYearly
                                    .totalprice
                                }{" "}
                                – Y
                              </span>
                            </p>
                          </Col>

                          {/* RIGHT SIDE: Overall Revenue */}
                          <Col sm={6}>
                            <h4 className="mb-2 text-lg font-semibold">
                              $
                              {
                                monthlyRevenue.currentMonthRevenueOverAll
                                  .totalprice
                              }{" "}
                              – M
                              <br />$
                              {
                                monthlyRevenue.currentRevenueOverallYearly
                                  .totalprice
                              }{" "}
                              – Y
                            </h4>
                            <p className="d-flex gap-1 text-sm text-muted">
                              <span>{key.label} (Overall)</span> –
                              <span style={{ color: "#f5aa33" }}>
                                {
                                  monthlyRevenue.currentMonthRevenueOverAll
                                    .currentMonthName
                                }
                              </span>
                            </p>

                            {/* Change % Overall */}
                            <p className="status-percentage my-2 text-sm">
                              <span
                                className={
                                  monthlyRevenue.currentMonthRevenueOverAll
                                    .totalprice >
                                  monthlyRevenue.previousMonthRevenueOverAll
                                    .totalprice
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {monthlyRevenue.currentMonthRevenueOverAll
                                  .totalprice >
                                monthlyRevenue.previousMonthRevenueOverAll
                                  .totalprice ? (
                                  <ArrowUp className="text-success me-1" />
                                ) : (
                                  <ArrowDown className="text-danger me-1" />
                                )}
                                {(() => {
                                  const curr = parseFloat(monthlyRevenue.currentMonthRevenueOverAll.totalprice) || 0;
                                  const prev = parseFloat(monthlyRevenue.previousMonthRevenueOverAll.totalprice) || 0;
                                  const denom = curr > prev ? curr : prev;
                                  return denom === 0 ? "0.00" : (Math.abs(curr - prev) / denom).toFixed(2);
                                })()}
                                %
                              </span>
                              <span className="ms-2">Since last month</span>
                            </p>

                            {/* Previous Overall */}
                            <p className="d-flex gap-1 status-percentage mt-3 text-sm">
                              <span>
                                {
                                  monthlyRevenue.previousMonthRevenueOverAll
                                    .previousMonthName
                                }
                              </span>{" "}
                              –
                              <span style={{ color: "#f5aa33" }}>
                                $
                                {
                                  monthlyRevenue.previousMonthRevenueOverAll
                                    .totalprice
                                }{" "}
                                – M
                              </span>
                              |
                              <span style={{ color: "#f5aa33" }}>
                                $
                                {
                                  monthlyRevenue.previousRevenueOverallYearly
                                    .totalprice
                                }{" "}
                                – Y
                              </span>
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  )}

                  {key.type === "retention" && (
                    <Col index={index} xs={12} md={6}>
                      <div className="grid-box">
                        <Row className="content-overview align-items-start">
                          {/* Regular Retention Column */}
                          <Col sm={6} className="">
                            <h2>
                              {widgetretention.currentMonthRetentionPercent}%
                            </h2>
                            <p className="status-percentage">
                              {widgetretention.currentMonthActiveRecords} out of{" "}
                              {widgetretention.currentMonthTotalRecords}
                            </p>
                            <p className="mt-0 d-flex gap-1">
                              <span>{key.label}</span> -{" "}
                              <span style={{ color: "#f5aa33" }}>
                                {
                                  monthlyRevenue.currentMonthRevenue
                                    .currentMonthName
                                }
                              </span>
                            </p>
                            <p className="status-percentage">
                              Since last month
                            </p>
                            <p className="status-percentage d-flex gap-1">
                              <span>
                                {
                                  monthlyRevenue.previousMonthRevenue
                                    .previousMonthName
                                }
                              </span>
                              <span>
                                {widgetretention.previousMonthRetentionPercent}%
                              </span>
                            </p>
                            <p className="status-percentage">
                              {widgetretention.previousMonthActiveRecords} out
                              of {widgetretention.previousMonthTotalRecords}
                            </p>
                          </Col>

                          {/* Overall Retention Column */}
                          <Col sm={6} className="">
                            <h2>
                              {
                                widgetretention.currentMonthRetentionPercentOverAll
                              }
                              %
                            </h2>
                            <p className="status-percentage">
                              {widgetretention.currentMonthActiveRecordsOverAll}{" "}
                              out of{" "}
                              {widgetretention.currentMonthTotalRecordsOverAll}
                            </p>
                            <p className="mt-0 d-flex gap-1">
                              <span>{key.label} (Overall)</span> -{" "}
                              <span style={{ color: "#f5aa33" }}>
                                {
                                  monthlyRevenue.currentMonthRevenue
                                    .currentMonthName
                                }
                              </span>
                            </p>
                            <p className="status-percentage">
                              Since last month
                            </p>
                            <p className="status-percentage d-flex gap-1">
                              <span>
                                {
                                  monthlyRevenue.previousMonthRevenue
                                    .previousMonthName
                                }
                              </span>
                              <span>
                                {
                                  widgetretention.previousMonthRetentionPercentOverAll
                                }
                                %
                              </span>
                            </p>
                            <p className="status-percentage">
                              {
                                widgetretention.previousMonthActiveRecordsOverAll
                              }{" "}
                              out of{" "}
                              {widgetretention.previousMonthTotalRecordsOverAll}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  )}
                </>
              ))}
            </Row>
            <Row className="grid-box-row p-0 mt-3">
              <Col xs={12} md={7} className="">
                <div className="grid-box m-0">
                  <div className="grid-box-heading d-flex justify-content-between align-items-center">
                    <div className="">
                      <h4 style={{ color: "#f5aa33" }}>Store Listing</h4>
                    </div>
                    <div className="boxsize boxsize-transparent p-2">
                      <button
                        className={
                          showdropdownfilter.status === "all"
                            ? "active fs-6"
                            : "fs-6"
                        }
                        onClick={setAll}
                      >
                        All
                      </button>
                      <button
                        className={
                          showdropdownfilter.status === "Active"
                            ? "active fs-6"
                            : "fs-6"
                        }
                        onClick={setActive}
                      >
                        Active
                      </button>
                      <button
                        className={
                          showdropdownfilter.status === "inActive"
                            ? "active fs-6"
                            : "fs-6"
                        }
                        onClick={setInActive}
                      >
                        InActive
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive 99999">
                    <Tablelist
                      tabledata={users.tabledata}
                      loading={users.loading}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={5} className="mb-4">
                <div className="grid-box justify-content-between">
                  {/* Heading */}
                  <div className="grid-box-heading">
                    {/* Dropdowns and Calendar */}
                    <Row className="align-items-end g-3">
                      {/* Plan Name Dropdown */}
                      <Col xs={12} sm={4}>
                        <label className="form-label text-warning fw-semibold">
                          Plan
                        </label>
                        <div className="dropdown">
                          <button
                            className="dropdown-toggle w-100 d-flex justify-content-between align-items-center p-2 rounded-2 border text-warning"
                            id="planname"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {
                              filters.planname.list.find(
                                (plan) =>
                                  plan.label === filters.planname.default.label
                              )?.label
                            }
                          </button>
                          <div
                            className="dropdown-menu w-100 p-2"
                            aria-labelledby="planname"
                          >
                            {filters.planname.list.map((plan, index) => (
                              <div
                                key={index}
                                className={`dropdown-item ${
                                  plan.label === filters.planname.default.label
                                    ? "text-warning fw-semibold"
                                    : ""
                                }`}
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    planname: {
                                      ...prev.planname,
                                      default: { label: plan.label },
                                      triger: true,
                                    },
                                  }))
                                }
                              >
                                {plan.label}
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>

                      {/* Date Range Picker */}
                      <Col xs={12} sm={8} className="position-relative">
                        <label className="form-label text-warning fw-semibold">
                          Date Range
                        </label>
                        <div
                          className="form-control date-range d-flex align-items-center gap-2"
                          onClick={() => setShowCalendar(!showCalendar)}
                          style={{ cursor: "pointer" }}
                        >
                          <Calendar2 />
                          {localRange[0] && localRange[1]
                            ? `${formatDate(localRange[0])} to ${formatDate(
                                localRange[1]
                              )}`
                            : "Select Date Range"}
                        </div>

                        {showCalendar && (
                          <div
                            ref={calendarRef}
                            className="position-absolute bg-white shadow p-2 rounded"
                            style={{ zIndex: 9999, right: 0 }}
                          >
                            <DateRange
                              editableDateInputs={true}
                              onChange={handleDateChange}
                              moveRangeOnFirstSelection={false}
                              ranges={range}
                              maxDate={new Date()}
                              locale={enUS}
                              direction="horizontal"
                            />

                            {/* Clear Button */}
                            <div className="d-flex justify-content-end mt-2">
                              <button
                                className="btn btn-sm btn-outline-warning"
                                onClick={() => {
                                  setLocalRange([null, null]);
                                  setRange([
                                    {
                                      startDate: new Date(),
                                      endDate: new Date(),
                                      key: "selection",
                                    },
                                  ]);
                                  // setShowCalendar(false);
                                }}
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>

                  {/* Pie Chart Section */}
                  <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                    <PieCharts
                      data={charttabledata.tbody}
                      data992={1.5}
                      irr={75}
                      orr={100}
                      DataKey={"value"}
                    />
                  </div>
                  <Tablelist
                    tabledata={charttabledata}
                    loading={users.loading}
                  />
                </div>
              </Col>
            </Row>
            <Row className="grid-box-row p-0 mt-3">
              <Col xs={12} md={6} className="">
                <div className="grid-box m-0">
                  <div className="grid-box-heading">
                    <div className="">
                      <h4 style={{ color: "#f5aa33" }}>
                        Country Wise Installs
                      </h4>
                    </div>
                    <div className="dropdown">
                      <button
                        style={{ color: "#f5aa33" }}
                        className="dropdown-toggle p-2 rounded-2 fs-6"
                        id="dropdownexecute"
                        aria-haspopup="true"
                        aria-expanded="false"
                        data-bs-toggle="dropdown"
                      >
                        {countryWiseInstalls.frequency === "all" && (
                          <>All Time</>
                        )}
                        {countryWiseInstalls.frequency === "week" && (
                          <>Last 7 DAYS</>
                        )}
                        {countryWiseInstalls.frequency === "month" && (
                          <>Last 30 DAYS</>
                        )}
                        {countryWiseInstalls.frequency === "thisweek" && (
                          <>This Week</>
                        )}
                        {countryWiseInstalls.frequency === "thismonth" && (
                          <>This Month</>
                        )}
                      </button>
                      <div
                        className="dropdown-menu boxsize boxsize-transparent p-2"
                        aria-labelledby="dropdownexecute"
                      >
                        <button
                          className={
                            countryWiseInstalls.frequency === "all"
                              ? "dropdown-item fs-6 text-start active"
                              : "dropdown-item fs-6 text-start"
                          }
                          onClick={() =>
                            setCountryWiseInstalls({
                              ...countryWiseInstalls,
                              frequency: "all",
                            })
                          }
                        >
                          All Time
                        </button>
                        <hr className="dropdown-divider" />
                        <button
                          className={
                            countryWiseInstalls.frequency === "thisweek"
                              ? "dropdown-item fs-6 active text-start"
                              : "dropdown-item fs-6 text-start"
                          }
                          onClick={() =>
                            setCountryWiseInstalls({
                              ...countryWiseInstalls,
                              frequency: "thisweek",
                            })
                          }
                        >
                          This Week
                        </button>
                        <hr className="dropdown-divider" />
                        <button
                          className={
                            countryWiseInstalls.frequency === "thismonth"
                              ? "dropdown-item fs-6 active text-start"
                              : "dropdown-item fs-6 text-start"
                          }
                          onClick={() =>
                            setCountryWiseInstalls({
                              ...countryWiseInstalls,
                              frequency: "thismonth",
                            })
                          }
                        >
                          This Month
                        </button>
                        <hr className="dropdown-divider" />
                        <button
                          className={
                            countryWiseInstalls.frequency === "week"
                              ? "dropdown-item fs-6 active text-start"
                              : "dropdown-item fs-6 text-start"
                          }
                          onClick={() =>
                            setCountryWiseInstalls({
                              ...countryWiseInstalls,
                              frequency: "week",
                            })
                          }
                        >
                          Last 7 Days
                        </button>
                        <hr className="dropdown-divider" />
                        <button
                          className={
                            countryWiseInstalls.frequency === "month"
                              ? "dropdown-item fs-6 active text-start"
                              : "dropdown-item fs-6 text-start"
                          }
                          onClick={() =>
                            setCountryWiseInstalls({
                              ...countryWiseInstalls,
                              frequency: "month",
                            })
                          }
                        >
                          Last 30 Days
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive 7777777">
                    <Tablelist tabledata={countryWiseInstalls.tabledata} />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="grid-box">
                  <p>Pie Chart for the country legends</p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </>
  );
};
export default Widgets;
